import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import config from '../../../config';
import { getItem } from '../../utils/localStorageFn';
import decodeToken from '../../utils/decodeToken';
import { handleApiErrors, manualLogout } from '../../utils/handleApiErrors';
import { getAuthToken } from '../../utils/auth';
import { getNextToken } from './getNextToken';
import { editUser, editPublisher } from '../../actions';

const useFetchUser = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const user = useSelector((state) => state.user.user);
  const accessToken = getAuthToken();

  useEffect(() => {
    (async () => {
      if (!user && accessToken) {
        const decoded = decodeToken(accessToken);
        if (decoded.exp * 1000 <= Date.now()) {
          await getNextToken();
        }

        const newAccessToken = getAuthToken();
        const newDecoded = decodeToken(newAccessToken);
        const domain = getItem('domain');

        try {
          const response = await fetch(
            `${config.ApiBaseUrl}/user/${newDecoded.username}`,
            {
              headers: {
                Authorization: `Bearer ${newAccessToken}`,
              },
            }
          );

          const verifiedResponse = handleApiErrors(response);
          const json = await verifiedResponse.json();
          const { data, message, success } = json;

          if (!success)
            throw new Error(
              message ?? 'Something went wrong. failed to process request'
            );
          dispatch(editUser(data));

          const response2 = await fetch(
            `${config.ApiBaseUrl}/wordpress/get/${domain}`,
            {
              headers: {
                Authorization: `Bearer ${newAccessToken}`,
              },
            }
          );
          const json2 = await response2.json();

          console.log(json2);

          if (!json2.success)
            throw new Error(
              json2.message ?? 'Something went wrong. failed to process request'
            );

          dispatch(editPublisher(json2.data));
        } catch (e) {
          if (e.message.includes('Unauthorized')) {
            manualLogout();
            history.push('/');
          }
        }
      }
    })();
  }, [user]);
};

export default useFetchUser;
